module.exports = __webpack_public_path__ + "img/ws-2.9be39ae3.jpg";